import { Action } from '@ngrx/store';
import { EAuthenticationActions } from '../../../../security/security-authentication/store/actions/authentication.actions';
import { IRPAAutomationAnywhereBot, IRPAAutomationAnywhereBots, IRPAAutomationAnywhereDevice, IRPAAutomationAnywherePoolDevice, IRPAAutomationAnywhereUser, IRpaConnectionAutomationAnywhere } from 'app/rpa-bots/core/IRpaBots';

export enum EAutomationAnywhereConnActions {
    AutomationAnywhereConnList = '[AutomationAnywhere Connectors] List of connectors from AutomationAnywhere',
    AutomationAnywhereConnListSuccess = '[AutomationAnywhere Connectors] List of connectors from AutomationAnywhere Success',
    GetCurrentAutomationAnywhereConn = '[AutomationAnywhere Connectors] Set the selected connector from server',
    GetCurrentAutomationAnywhereConnSuccess = '[AutomationAnywhere Connectors] Set the selected connector from server success',
    GetAutomationAnywhereBots = '[AutomationAnywhere Connectors] Getthe available bots of AutomationAnywhere',
    GetAutomationAnywhereDevices = '[AutomationAnywhere Connectors] Getthe available devices of AutomationAnywhere',
    GetAutomationAnywherePoolDevices = '[AutomationAnywhere Connectors] Get the available pooldevices of AutomationAnywhere',
    GetAutomationAnywhereUsers = '[AutomationAnywhere Connectors] Get the available users of AutomationAnywhere',
    UpdateAutomationAnywhereConn = '[AutomationAnywhere Connectors] Update selected AutomationAnywhere connector',
    UpdateAutomationAnywhereConnSuccess = '[AutomationAnywhere Connectors] Update selected AutomationAnywhere connector Success',
    ShowSuccessToast = '[AutomationAnywhere Connectors] Show Success toast from update action',
    ResetAutomationAnywhereState = ' [AutomationAnywhere Connectors] Reset automation anywhere state',
    TestAutomationAnywhereConn = '[AutomationAnywhere Connectors] Test selected AutomationAnywhere connector',
    GetVersionAutomationAnywhere ='[AutomationAnywhere Connectors] Get Version AutomationAnywhere current connection',
    TestAutomationAnywhereConnSuccess = '[AutomationAnywhere Connectors] Test selected AutomationAnywhere connector Success',
    GetVersionAutomationAnywhereSuccess ='[AutomationAnywhere Connectors] Get Version AutomationAnywhere current connection success',
    SetAABotsSuccess = '[AutomationAnywhere Connectors] Set Automation Anywhere Bots after calling service',
    SetAADevicesSuccess = '[AutomationAnywhere Connectors] Set Automation Anywhere Devices after calling service',
    SetAAPoolDevicesSuccess = '[AutomationAnywhere Connectors] Set Automation Anywhere pool devices after calling service',
    SetAAUsersSuccess = '[AutomationAnywhere Connectors] Set Automation Anywhere Users after calling service',
    ResetDeviceBotSelection = '[AutomationAnywhere Connectors] Reset device and bot selection state',
    UpdateAutomationAnywhereBotProcess = '[AutomationAnywhere Connectors] update AutomationAnywhere process'
}

export class AutomationAnywhereConnList implements Action {
    public readonly type = EAutomationAnywhereConnActions.AutomationAnywhereConnList;
}

export class AutomationAnywhereConnListSuccess implements Action {
    public readonly type = EAutomationAnywhereConnActions.AutomationAnywhereConnListSuccess;
    constructor(public payload: IRpaConnectionAutomationAnywhere[]) { }
}

export class GetCurrentAutomationAnywhereConn implements Action {
    public readonly type = EAutomationAnywhereConnActions.GetCurrentAutomationAnywhereConn;
    constructor(public payload: string) { } // Payload is the id of connector
}

export class GetCurrentAutomationAnywhereConnSuccess implements Action {
    public readonly type = EAutomationAnywhereConnActions.GetCurrentAutomationAnywhereConnSuccess;
    constructor(public payload: IRpaConnectionAutomationAnywhere) { }
}

export class GetAutomationAnywhereBots implements Action{
    public readonly type = EAutomationAnywhereConnActions.GetAutomationAnywhereBots;
    constructor(public payload: IRpaConnectionAutomationAnywhere) { }
}

export class GetAutomationAnywhereDevices implements Action{
    public readonly type = EAutomationAnywhereConnActions.GetAutomationAnywhereDevices;
    constructor(public payload: IRpaConnectionAutomationAnywhere) { }
}

export class GetAutomationAnywherePoolDevices implements Action{
    public readonly type = EAutomationAnywhereConnActions.GetAutomationAnywherePoolDevices;
    constructor(public payload: IRpaConnectionAutomationAnywhere) { }
}

export class GetAutomationAnywhereUsers implements Action{
    public readonly type = EAutomationAnywhereConnActions.GetAutomationAnywhereUsers;
    constructor(public payload: IRpaConnectionAutomationAnywhere) { }
}

export class UpdateAutomationAnywhereBotProcess implements Action{
    public readonly type = EAutomationAnywhereConnActions.UpdateAutomationAnywhereBotProcess;
    constructor(public payload: IRPAAutomationAnywhereBots) { }
}

export class UpdateAutomationAnywhereConn implements Action {
    public readonly type = EAutomationAnywhereConnActions.UpdateAutomationAnywhereConn;
    constructor(public payload: IRpaConnectionAutomationAnywhere) { }
}

export class UpdateAutomationAnywhereConnSuccess implements Action {
    public readonly type = EAutomationAnywhereConnActions.UpdateAutomationAnywhereConnSuccess;
}

export class ShowSuccessToast implements Action {
    public readonly type = EAutomationAnywhereConnActions.ShowSuccessToast;
}

export class ResetAutomationAnywhereState implements Action {
    public readonly type = EAutomationAnywhereConnActions.ResetAutomationAnywhereState;
}

export class TestAutomationAnywhereConn implements Action {
    public readonly type = EAutomationAnywhereConnActions.TestAutomationAnywhereConn;
    constructor(public payload: IRpaConnectionAutomationAnywhere) { }
}

export class GetVersionAutomationAnywhere implements Action {
    public readonly type = EAutomationAnywhereConnActions.GetVersionAutomationAnywhere;
    constructor(public payload: IRpaConnectionAutomationAnywhere) { }
}

export class GetVersionAutomationAnywhereSuccess implements Action {
    public readonly type = EAutomationAnywhereConnActions.GetVersionAutomationAnywhereSuccess;
    constructor(public payload: string) { }
}

export class SetAABotsSuccess implements Action {
    public readonly type = EAutomationAnywhereConnActions.SetAABotsSuccess;
    constructor(public payload: IRPAAutomationAnywhereBot[]) { }
}
export class SetAADevicesSuccess implements Action {
    public readonly type = EAutomationAnywhereConnActions.SetAADevicesSuccess;
    constructor(public payload: IRPAAutomationAnywhereDevice[]) { }
}
export class SetAAPoolDevicesSuccess implements Action {
    public readonly type = EAutomationAnywhereConnActions.SetAAPoolDevicesSuccess;
    constructor(public payload: IRPAAutomationAnywherePoolDevice[]) { }
}
export class SetAAUsersSuccess implements Action {
    public readonly type = EAutomationAnywhereConnActions.SetAAUsersSuccess;
    constructor(public payload: IRPAAutomationAnywhereUser[]) { }
}
export class TestAutomationAnywhereConnSuccess implements Action {
    public readonly type = EAutomationAnywhereConnActions.TestAutomationAnywhereConnSuccess;
    constructor() { }
}


export class ResetDeviceBotSelection implements Action {
    public readonly type = EAutomationAnywhereConnActions.ResetDeviceBotSelection;
    constructor() { }
}



export type AutomationAnywhereConnActions = AutomationAnywhereConnList |
    AutomationAnywhereConnListSuccess |
    GetCurrentAutomationAnywhereConn |
    GetCurrentAutomationAnywhereConnSuccess |
    UpdateAutomationAnywhereConn |
    UpdateAutomationAnywhereConnSuccess |
    UpdateAutomationAnywhereBotProcess |
    ShowSuccessToast |
    ResetAutomationAnywhereState
    | ResetDeviceBotSelection
    | TestAutomationAnywhereConn
    | TestAutomationAnywhereConnSuccess
    | GetVersionAutomationAnywhere
    | GetVersionAutomationAnywhereSuccess
    | GetAutomationAnywhereBots
    | GetAutomationAnywhereDevices
    | GetAutomationAnywherePoolDevices
    | GetAutomationAnywhereUsers
    | SetAABotsSuccess
    | SetAADevicesSuccess
    | SetAAPoolDevicesSuccess
    | SetAAUsersSuccess;
